export function extractAuthTokenPayload(envelope, response, fallbackMessage) {
  if (envelope?.error) {
    const err = new Error(envelope.error?.message ?? fallbackMessage);
    err.response = response;
    throw err;
  }

  if (!envelope?.access_token) {
    const err = new Error('Brak access_token w odpowiedzi serwera');
    err.response = response;
    throw err;
  }

  return envelope;
}
